import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

const NAV_ITEMS = [
  { path: '/admin/dashboard', label: 'לוח בקרה' },
  { path: '/admin/requests', label: 'בקשות' },
  { path: '/admin/businesses', label: 'עסקים' },
  { path: '/admin/cities', label: 'ערים' },
  { path: '/admin/users', label: 'משתמשים' },
  { path: '/admin/blocked-customers', label: 'חסומים' },
  { path: '/admin/message-stats', label: 'הודעות' },
];
const LIGHT_LOGO_SRC = '/updated%20dark%20mode%20logo.png';
const DARK_LOGO_SRC = '/updated%20dark%20mode%20logo.png';

function AdminNavbar({ admin, onLogout, theme, onToggleTheme }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isDark = theme === 'dark';
  const headerLogoSrc = isDark ? DARK_LOGO_SRC : LIGHT_LOGO_SRC;

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(`${path}/`);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!mobileMenuOpen) return;

    const onKeyDown = (e) => {
      if (e.key === 'Escape') setMobileMenuOpen(false);
    };

    window.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const closeMobileMenu = () => setMobileMenuOpen(false);
  const go = (path) => {
    closeMobileMenu();
    navigate(path);
  };

  return (
    <nav className="navbar admin-navbar" style={{background: 'linear-gradient(135deg, #1a1a2e 0%, #2d2d44 60%, #c9a96e 100%)', boxShadow: '0 4px 20px rgba(201, 169, 110, 0.3)'}}>
      <div className="container navbar-content">
        <div className="logo" style={{cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '12px'}} onClick={() => navigate('/admin/dashboard')}>
          <img src={headerLogoSrc} alt="תן לי תור" className="brand-banner" />
          <span className="admin-badge">מנהל</span>
        </div>

        <div className="nav-links admin-links" style={{display: 'flex', gap: '8px'}}>
          {NAV_ITEMS.map((item) => (
            <button
              key={item.path}
              type="button"
              onClick={() => navigate(item.path)}
              style={{
                padding: '10px 18px',
                borderRadius: '8px',
                background: isActive(item.path) ? 'rgba(255,255,255,0.25)' : 'transparent',
                fontWeight: isActive(item.path) ? '700' : '500',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                border: 'none',
                color: 'white',
                fontSize: 'inherit',
                fontFamily: 'inherit'
              }}
            >
              {item.label}
            </button>
          ))}
        </div>

        <div className="user-menu" style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
          <button
            className="navbar-hamburger"
            onClick={() => setMobileMenuOpen(true)}
            type="button"
            aria-label="פתח תפריט"
            aria-expanded={mobileMenuOpen}
            aria-controls="admin-mobile-nav-drawer"
          >
            ☰
          </button>
          <span className="username" style={{background: 'rgba(255,255,255,0.2)', padding: '8px 16px', borderRadius: '20px', fontWeight: '600'}}>
            👑 {admin?.username}
          </span>
          <button
            className="theme-toggle"
            onClick={onToggleTheme}
            type="button"
            style={{ background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none' }}
          >
            {theme === 'dark' ? '☀️ מצב בהיר' : '🌙 מצב כהה'}
          </button>
          <button 
            className="logout-btn" 
            onClick={handleLogout}
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              padding: '8px 20px',
              borderRadius: '8px',
              border: 'none',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
            onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
          >
            🚪 התנתק
          </button>
        </div>
      </div>

      <div
        className={mobileMenuOpen ? 'mobile-nav-overlay open' : 'mobile-nav-overlay'}
        role="presentation"
        onClick={closeMobileMenu}
      />

      <aside
        id="admin-mobile-nav-drawer"
        className={mobileMenuOpen ? 'mobile-nav-drawer open' : 'mobile-nav-drawer'}
        aria-hidden={!mobileMenuOpen}
      >
        <div className="mobile-nav-header">
          <div className="mobile-nav-title">מנהל · תפריט</div>
          <button className="mobile-nav-close" type="button" onClick={closeMobileMenu} aria-label="סגור">
            ✕
          </button>
        </div>

        <div className="mobile-nav-user">👑 {admin?.username || ''}</div>

        <nav className="mobile-nav-links" aria-label="ניווט מנהל">
          {NAV_ITEMS.map((item) => (
            <button key={item.path} type="button" className="mobile-nav-link" onClick={() => go(item.path)}>{item.label}</button>
          ))}
        </nav>

        <div className="mobile-nav-actions">
          <button type="button" className="mobile-nav-action" onClick={() => { closeMobileMenu(); onToggleTheme(); }}>
            {theme === 'dark' ? '☀️ מצב בהיר' : '🌙 מצב כהה'}
          </button>
          <button type="button" className="mobile-nav-action danger" onClick={() => { closeMobileMenu(); handleLogout(); }}>
            🚪 התנתק
          </button>
        </div>
      </aside>
    </nav>
  );
}

export default AdminNavbar;
